import { ReactComponent as Icon } from "../assets/icons/chats/Close.svg";
import genIcons from "./genIcons";

const Close = { Outline: genIcons(Icon, {style: { width: "12px" , height: "12px" , }}) };

export default Close;
